// extracted by mini-css-extract-plugin
export default {"title":"ModalConfirmarExclusao_title__rwJzy","body":"ModalConfirmarExclusao_body__JsQQ5"};